import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { useSettings } from '../context/SettingsContext';
import { getCompanyStats } from '../config/companyStats';
import './AboutPage.css';

function AboutPage() {
  const settings = useSettings();
  const stats = getCompanyStats(settings);
  return (
    <div className="about-page">
      <SEO
        title="About Us - Melbourne Awning & Pergola Supplier"
        description="ASG Shading supplies premium retractable awnings and high-grade aluminium pergola systems across Melbourne. Custom-engineered for Australian conditions."
        keywords="about ASG Shading, awning supplier Melbourne, pergola supplier Melbourne, outdoor living specialists, aluminium pergola supplier"
        canonical="/about"
        jsonLd={[SEO.organizationSchema, SEO.breadcrumbSchema([{ name: 'About' }]), SEO.webPageSchema({ type: 'AboutPage', name: 'About ASG Shading', description: 'ASG Shading supplies premium retractable awnings and high-grade aluminium pergola systems across Melbourne.', url: '/about' })]}
      />
      <section className="ap-hero">
        <div className="ap-hero-bg"></div>
        <div className="ap-hero-content">
          <p className="ap-label">Our Story</p>
          <h1 className="ap-title">About ASG Shading</h1>
          <p className="ap-subtitle">Building premium outdoor living spaces across Melbourne since day one.</p>
        </div>
      </section>

      <Breadcrumbs items={[{ name: 'About' }]} />

      <section className="ap-story">
        <div className="ap-story-inner">
          <div className="ap-story-text">
            <h2>Who We Are</h2>
            <p>
              ASG Shading specialises in two things: a curated range of motorised retractable awnings,
              made to measure and delivered across Melbourne, and the supply of premium custom aluminium
              pergola systems for residential and commercial properties. Every product is engineered to
              suit your space, your style, and the Australian climate.
            </p>
            <p>
              We use only high-strength aluminium alloy with a multi-stage protective finish -
              engineered to resist corrosion, UV degradation and the demands of the Australian climate.
              From louvered roofs that adjust with the weather to fully retractable systems that open
              up to the sky, we build structures that transform how you use your outdoor space.
            </p>
          </div>
          <div className="ap-story-img"></div>
        </div>
      </section>

      <section className="ap-values">
        <div className="ap-values-inner">
          <h2 className="ap-values-title">What Sets Us Apart</h2>
          <div className="ap-values-grid">
            <div className="ap-value-card">
              <div className="ap-value-num">01</div>
              <h3>Custom Engineering</h3>
              <p>Every system is designed and built to your exact specifications. No off-the-shelf solutions.</p>
            </div>
            <div className="ap-value-card">
              <div className="ap-value-num">02</div>
              <h3>Delivery</h3>
              <p>Free delivery to most of Melbourne, $150 flat to the outer suburbs, and freight quoted anywhere else in Australia.</p>
            </div>
            <div className="ap-value-card">
              <div className="ap-value-num">03</div>
              <h3>Quality Materials</h3>
              <p>Corrosion-resistant aluminium with a durable powder-coat finish throughout. Built for Australian conditions and backed by warranty.</p>
            </div>
            <div className="ap-value-card">
              <div className="ap-value-num">04</div>
              <h3>Local Expertise</h3>
              <p>Melbourne-based team with deep knowledge of local building codes, weather patterns, and architectural styles.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="ap-stats">
        <div className="ap-stats-inner">
          {stats.map((st, i) => (
            <div className="ap-stat" key={i}>
              <div className="ap-stat-num">{st.num}</div>
              <div className="ap-stat-label">{st.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="ap-cta">
        <div className="ap-cta-inner">
          <h2>Ready to get started?</h2>
          <p>Get in touch for a no-obligation quote - send us photos and measurements and we'll advise remotely.</p>
          <Link to="/contact" className="ap-cta-btn">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
